import React from 'react';
import styled from "styled-components";

function TimeSwitcher(props) {

    const dataRange = [{
        id: 0, name: 'Daily', value: 'daily',
    }, {
        id: 1, name: 'Weekly', value: 'weekly',
    }, {
        id: 2, name: 'Monthly', value: 'monthly',
    }]

    return (<TimeInfo>
            {
                dataRange.map((listItem) => {
                return (<li key={listItem.id} onClick={(e) => props.onViewUpdate(e.target)}>{listItem.name}</li>)
            })
            }
        </TimeInfo>);
}


const TimeInfo = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--default-padding);
  margin: 0px;
  padding: 0px;
  list-style-type: none;

  li {
    padding: 0px;
    color: var(--pale-blue);
    cursor: pointer;

    &:hover {
      color: white;
    }
  }
`

export default TimeSwitcher;